import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import Title from "../../ui/Title";
import { useEffect, useState } from "react";
import { ReturnsFormType } from "../returns/AddReturns";
import { usePickupAddress } from "../../../hooks/usePickupAddress";
import { useGetPickupAddress } from "../../../config/api";
import { StyledButton } from "../../ui/StyledButton";

const PickupAddressForm = ({
  label,
  handleNext,
  handleBack,
  setFinalForm,
  finalForm,
}: {
  label: string;
  handleNext: () => void;
  handleBack: () => void;
  setFinalForm: (finalForm: any) => void;
  finalForm: ReturnsFormType;
}) => {
  const { onOpen } = usePickupAddress();

  const { pickupAddress } = useGetPickupAddress();

  const [selectAddress, setSelectedAddress] = useState(pickupAddress[0]);

  useEffect(() => {
    setSelectedAddress(
      pickupAddress.filter(
        (el) => el.id === parseInt(finalForm?.receiver_address?.id as string)
      )[0] ?? pickupAddress[0]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFinalForm({
      ...finalForm,
      ...{
        receiver_address: {
          id: selectAddress?.id,
          address: selectAddress?.address,
          postal_code: `${selectAddress?.postal_code}`,
          city: selectAddress?.city,
          state: selectAddress?.state,
        },
        receiver_contact: {
          person_name: selectAddress?.person_name,
          company_name: selectAddress?.company_name,
          mobile_number: selectAddress?.mobile_number,
          email: selectAddress?.email,
        },
      },
    });
  }, [selectAddress]);

  const changeAddress = (id: number) => {
    const addressById = pickupAddress.findIndex((el) => {
      return id === el.id;
    });

    setSelectedAddress(pickupAddress[addressById]);
  };

  return (
    <>
      <Box>
        <Title title={`Add ${label}`} />
        <Typography marginBottom={"30px"}>Pickup Address</Typography>

        <Grid container columnSpacing={2}>
          {pickupAddress &&
            pickupAddress.map((address, index) => {
              return (
                <Grid key={index} item xs={12} sm={4} md={3}>
                  <Box
                    sx={{
                      height: "200px",
                      border: `1px solid ${selectAddress?.id === address.id ? "#0e1f2e" : "white"
                        }`,
                      margin: "12px 0",
                      borderRadius: "12px",
                      boxShadow: "1px 2px 7px 0px rgba(0, 0, 0, 0.2)",
                      transition: "all 0.3s",
                    }}
                  >
                    <Button
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        textAlign: "left",
                        gap: "60px",
                      }}
                      onClick={() => changeAddress(address.id)}
                    >
                      <div>
                        <Typography fontWeight={"500"}>
                          {address.nickname}
                        </Typography>
                      </div>
                      <div>
                        <Typography fontSize={"12px"}>
                          {address.address} <br />
                          ...
                        </Typography>
                        <Typography fontSize={"12px"}>
                          Mobile: {address.mobile_number}
                        </Typography>
                      </div>
                    </Button>
                  </Box>
                </Grid>
              );
            })}
        </Grid>
        <Box
          sx={{
            width: "200px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "0.2px dotted black",
            margin: "12px 0",
            borderRadius: "12px",
          }}
        >
          <Button
            sx={{
              width: "100%",
              height: "100%",
              fontSize: "10px",
            }}
            onClick={onOpen}
          >
            Add New Pickup Address
          </Button>
        </Box>
        <Stack
          flexDirection={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          marginTop={2}
          columnGap={2}
        >
          <StyledButton variant="contained" onClick={handleBack}>
            Back
          </StyledButton>
          <StyledButton
            disabled={selectAddress?.id ? false : true}
            variant="contained"
            onClick={handleNext}
          >
            Next
          </StyledButton>
        </Stack>
      </Box>
    </>
  );
};

export default PickupAddressForm;
